import React from 'react';
import { NavLink } from 'reactstrap';
import { NavLink as RouterNavLink } from 'react-router-dom';
import Icon from '@mdi/react';
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js';
import { CollapseMenu } from 'cd-eft/components/common/CollapseMenu';
import { observer } from 'mobx-react';
import { LoaderWithBar } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import { IContainerWithSideBarProps } from './ContainerWithSideBarVM';
import stores from 'cd-eft/models/Stores';
import './ContainerWithSideBar.scss';

const { designStore } = stores.AppStore;

export const ContainerWithSideBar = observer((props: IContainerWithSideBarProps) => {
  const { title, navigation, children, tab, collapseMenuClass, isCollapsed, setCollapsed } = props;

  return (
    <>
      <LoaderContainer />
      <CollapseMenu
        showAsHeader={true}
        title={title}
        noIcon={true}
        forceOpen={true}
        className={`designelement-container container-with-sidebar ${collapseMenuClass}`}
      >
        <nav className={`design-side-menu pt-0 ${isCollapsed ? 'collapsed' : ''}`} aria-label={`${title} Menu`}>
          {navigation.map((el) => (
            <SideBarItem key={el.name} {...el} isCollapsed={isCollapsed} tab={tab} />
          ))}

          <NavLink tag="button" className="collapse-menu-2" onClick={setCollapsed}>
            {isCollapsed ? (
              <Icon className="icon" path={mdiChevronRight} size={1.2} color="#ffffff" title="Collapse Sidebar" />
            ) : (
              <>
                <Icon className="icon" path={mdiChevronLeft} size={1.2} color="#ffffff" />
                <br />
                Collapse Sidebar
              </>
            )}
          </NavLink>
        </nav>

        <div className={`container-with-sidebar-content ${tab}`}>{children}</div>
      </CollapseMenu>
    </>
  );
});

const LoaderContainer = observer(() => {
  return (
    <>
      {designStore.isLoading && (
        <LoaderWithBar
          message={designStore.loadingMsg}
          className={'design-container-loader'}
          processName={designStore.processName}
          loadingProgress={designStore.loadingProgress}
          loading={designStore.isLoading}
        />
      )}
    </>
  );
});

interface ISideBarItemProps {
  name: string;
  title: string;
  icon: any;
  isCollapsed: boolean;
  link: string;
}

const SideBarItem = observer(({ name, title, icon, link, isCollapsed }: ISideBarItemProps) => (
  <RouterNavLink
    to={link}
    data-testid={name}
    activeClassName="active-design-item"
    className={`design-side-menu-button ${isCollapsed ? 'pb-2' : ''}`}
  >
    <Icon path={icon} title={title} size={1.2} />
    {isCollapsed ? null : <div>{title}</div>}
  </RouterNavLink>
));
